<template>
  <div>
    <v-container>
      <div class="text-xs-right mb-2">
        <v-btn @click="exportData" color="grey" outline class="ma-0 mb-1">
          <em class="fas fa-file-export mr-1" />
          {{ $t('export') }}
        </v-btn>
      </div>
      <div>
        <DateFilter
          @changeDate="getData"
          :defaultFilter="'today'"
          :showTime="true"
          v-model="selectedDate"
        ></DateFilter>
      </div>
      <div class="my-3">
        <v-card class="pa-3">
          <v-layout wrap>
            <v-flex xs6 class="text-xs-left">
              <template
                v-if="
                  ['109154847972476', '109181747969457', '178737485661189'].includes(
                    selectedBot.pageid
                  )
                "
              >
                <Multiselect
                  @input="onFilterPage($event)"
                  placeholder="เลือกเพจ"
                  v-model="filter.page"
                  :options="pageOptions"
                  label="text"
                  track-by="value"
                  :allow-empty="false"
                  :show-labels="false"
                ></Multiselect>
              </template>
            </v-flex>
            <v-flex xs6 class="text-xs-right">
              Total:
              <span class="primary--text" style="font-weight: 600; font-size: 20px">
                {{ data.length }}
              </span>
            </v-flex>
          </v-layout>
        </v-card>
      </div>
      <v-data-table
        :loading="loading"
        :headers="filteredHeader"
        :items="data"
        class="elevation-1"
        v-bind:pagination.sync="pagination"
        hide-actions
      >
        <template v-slot:items="props">
          <td>
            <v-avatar size="30">
              <img
                v-if="props.item.profile_pic"
                :src="props.item.profile_pic"
                width="30"
                height="30"
                :alt="props.item.first_name + ' ' + props.item.last_name"
              />
              <img
                v-else
                :src="'/static/img/assets/livechat/profile.png'"
                width="30"
                height="30"
                :alt="props.item.first_name + ' ' + props.item.last_name"
              />
            </v-avatar>
          </td>
          <td
            style="min-width: 300px"
            :title="
              (props.item.first_name ? props.item.first_name : '') +
              ' ' +
              (props.item.last_name ? props.item.last_name : '')
            "
          >
            <div style="display: inline-block; vertical-align: top; margin-top: 5px">
              {{
                ((props.item.first_name ? props.item.first_name : '') +
                  ' ' +
                  (props.item.last_name ? props.item.last_name : ''))
                  | truncate(35)
              }}
            </div>
          </td>

          <td>{{ props.item.cardnumber ? $t(props.item.cardnumber) : '-' }}</td>
          <td>{{ props.item.realname ? $t(props.item.realname) : '-' }}</td>
          <td>{{ props.item.address ? $t(props.item.address) : '-' }}</td>
          <td class="text-xs-center">
            {{
              props.item.timestamp ? getFormatDate(props.item.timestamp, 'DD/MM/YYYY HH:mm') : '-'
            }}
          </td>
          <td class="text-xs-center">
            <span style="color: #3b5998" v-if="props.item.app == 'facebook'">
              <em class="fab fa-facebook-square" />
            </span>
            <span style="color: #00c300" v-else-if="props.item.app == 'line'">
              <em class="fab fa-line" />
            </span>
          </td>
          <td>{{ props.item.gender ? $t(props.item.gender) : '-' }}</td>

          <td class="text-xs-center">
            {{ props.item.email ? props.item.email : '-' }}
          </td>
          <td class="text-xs-center">
            {{ props.item.phoneno ? props.item.phoneno : '-' }}
          </td>
          <td class="text-xs-center">
            {{ props.item.status ? props.item.status : '-' }}
          </td>
          <td class="text-xs-center" style="white-space: nowrap">
            <template v-if="userLocale(props.item)">
              <flag :iso="userLocale(props.item).icon" />
            </template>
            <template v-else>-</template>
          </td>
        </template>

        <div class="text-xs-center" slot="no-data">{{ $t('No customer') }}</div>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import { mapGetters } from 'vuex'
import CustomerItem from './CustomerItem'
import DateFilter from './DateFilter.vue'
import config from '@/config'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    CustomerItem,
    DateFilter,
    Multiselect
  },
  data() {
    return {
      pagination: { rowsPerPage: -1, sortBy: '' },
      loading: false,
      data: [],
      selectedDate: {
        start: moment().format('YYYY-MM-DD 00:00'),
        end: moment().format('YYYY-MM-DD 23:59')
      },
      filter: {
        page: ''
      },
      pageOptions: [
        {
          text: 'All',
          value: ''
        },
        {
          text: 'Test SCG West Live',
          value: '108496771338010'
        },
        {
          text: 'Western Chang Family Live',
          value: '100378482209868'
        },
        {
          text: 'Eastern Chang Family Live',
          value: '107060654853653'
        },
        {
          text: 'Chang Family Live Fair',
          value: '109181747969457'
        },
        {
          text: 'Chang Family Live',
          value: '109154847972476'
        },
        {
          text: 'Test SCG Chang Family',
          value: '100684322285177'
        },
        {
          text: 'Esan Chang Family Live',
          value: '103800371873416'
        },
        {
          text: 'สุทธิพงศ์ ค้าส่ง Live',
          value: '108308318379330'
        },
        {
          text: 'สินค้าซิเมนต์ไทย ค้าส่ง Live',
          value: '101127682506041'
        },
        {
          text: 'Northern Chang Family Live',
          value: '100274418904517'
        },
        {
          text: 'Sukhothaicemen Live',
          value: '108556638438120'
        },
        {
          text: 'Northern2 Chang Family Live',
          value: '108026141827592'
        },
        {
          text: 'เอสซีจี โฮมบุญถาวร ชุมแพ-เปรมปรีดิ์',
          value: '490162721055346'
        },
        {
          text: 'NPD - Test Live',
          value: '115739694445355'
        },
        {
          text: 'Southern Chang Family Live',
          value: '100396882225293'
        },
        {
          text: 'YALA YONG HUAD ยะลาย่งฮวด',
          value: '178737485661189'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    filteredHeader() {
      var header = [
        { text: '', sortable: false },
        { text: this.$t('name'), value: 'first_name' },
        { text: this.$t('Shop code'), value: 'cardnumber' },
        { text: this.$t('Shop name'), value: 'realname' },
        { text: this.$t('Province'), value: 'address' },
        { text: this.$t('เวลา Check-in'), value: 'timestamp' },
        { text: this.$t('Channel'), value: 'app' },
        { text: this.$t('gender'), value: 'gender' },

        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('phone no.'), value: 'phoneno' },
        { text: this.$t('Status'), value: 'status' },

        { text: this.$t('Locale'), value: 'locale' }
      ]
      return header
    }
  },
  async mounted() {
    if (
      ['109154847972476', '109181747969457', '178737485661189'].includes(this.selectedBot.pageid)
    ) {
      var currentPage = this.pageOptions.find((el) => {
        if (el.value == this.selectedBot.pageid) {
          return el
        }
      })

      this.filter.page = currentPage
    }
    await this.getData()
  },
  methods: {
    userLocale: function (item) {
      var vm = this
      return config.locale.find(function (locale) {
        if (item.locale == locale.value) {
          return locale.title
        }
      })
    },
    getFormatDate: function (date, format) {
      return moment(date).format(format)
    },
    getData() {
      return new Promise((resolve) => {
        this.loading = true
        var pageid = ''
        if (
          ['109154847972476', '109181747969457', '178737485661189'].includes(
            this.selectedBot.pageid
          )
        ) {
          //Chang Family Live Fair
          pageid = ''
          if (this.filter.page) {
            pageid = this.filter.page.value
          } else {
            pageid = this.selectedBot.pageid
          }
        } else {
          pageid = this.selectedBot.pageid
        }
        var data = {
          pageid: pageid,
          startdate: this.selectedDate.start,
          enddate: this.selectedDate.end
        }
        api.scgdistributiongetinterestusers(data, (err, response) => {
          this.data = response.data
          this.loading = false
          resolve()
        })
      })
    },
    exportData: function () {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }

      var csvdata =
        'Name,Shop code,Shop name,Province,เวลา Check-in,Channel,Gender,Email,Phone no.,Status,Locale\r\n'

      this.data.forEach((el) => {
        csvdata += `${el.first_name ? el.first_name + ` ${el.last_name}` : '-'},${
          el.cardnumber ? el.cardnumber : '-'
        },${el.realname ? el.realname : '-'},${el.address ? el.address : '-'},${
          el.timestamp ? moment(el.timestamp).format('YYYY-MM-DD HH:mm') : '-'
        },${el.app ? el.app : '-'},${el.gender ? el.gender : '-'},${el.email ? el.email : '-'},${
          el.phoneno ? el.phoneno : '-'
        },${el.status ? el.status : '-'},${el.locale ? el.locale : '-'}\r\n`
      })
      vm.exportCsv(csvdata, 'cartsummary')
    },
    onFilterPage(page) {
      this.filter.page = page
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/ScgdistributionInterest.vue